






































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { Group } from '@/router/group.model';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import ArrowDownIcon from '@/components/icons/Arrow.vue';

import LeftBarNotificationArrow from '@/componentsV2/molecules/LeftBarNotificationArrow/LeftBarNotificationArrow.vue';
import { getParentRoute } from '@/router';

@Component({
  components: {
    Typography,
    ArrowDownIcon,
    LeftBarNotificationArrow
  }
})
export default class TopBarNavGroupHeader extends Vue {
  @Prop(Group) readonly group!: Group;
  @Prop() title!: string;
  @Prop() disclaimer!: string;

  @Prop() notification?: any;
  @Prop({ default: true }) showArrow!: boolean;
  @Prop({ default: true }) opened!: boolean;
  @Prop() focusedId!: string;
  @Prop({ default: false }) actived!: boolean;

  menuTooltipOffset = {
    top: 0,
    left: 0
  };

  menuNotificationOffset = {
    top: 0,
    left: 0
  };

  get screenSmall() {
    return window.innerWidth <= 1280;
  }

  get focused() {
    return this.focusedId === this.group.id;
  }

  get styleDisclaimer() {
    let style = `left: ${this.menuTooltipOffset.left}px;top: ${
      this.menuTooltipOffset.top
    }px;`;

    if (!this.menuTooltipOffset.top) style += 'opacity: 0;';

    return style;
  }

  get showArrowNotification() {
    if (this.$mobileCheck() || !this.notification || !this.screenSmall)
      return false;

    if (this.notification.subGroupId)
      return this.group.id === this.notification.subGroupId;

    return this.group.id === this.notification.groupId;
  }

  get activedHeader() {
    const parentRoute = getParentRoute();

    // if some subgroup is focused
    if (
      this.group.routes
        .map((item: any) => item.id || item.name)
        .includes(this.focusedId)
    )
      return true;

    // if some subgroup route is selected
    if (
      parentRoute.meta.$group &&
      parentRoute.meta.$group.meta.$group &&
      parentRoute.meta.$group.meta.$group.id === this.group.id
    )
      return true;

    if (!this.group.routes.map(item => item.path).includes(parentRoute.path))
      return false;

    return this.actived || this.opened;
  }

  getMenuItemOffset(selector: string) {
    let { left, top, width, height } = this.$el.getBoundingClientRect();
    const el = this.$el.querySelector(selector) as HTMLElement;

    if (el) {
      const tooltipOffset = el.getBoundingClientRect();

      return {
        left: left + width,
        top: top + height / 2 - tooltipOffset.height / 2
      };
    }
    return { left: 0, top: 0 };
  }

  setMenuItemOffset() {
    this.menuTooltipOffset = this.getMenuItemOffset(
      '.menu-group-header__disclaimer'
    );
  }

  @Watch('notification')
  setMenuNotificationOffset() {
    if (!this.showArrowNotification) return;

    setTimeout(() => {
      this.$emit('collapse-click', true);
      this.menuNotificationOffset = this.getMenuItemOffset(
        '.notification-arrow'
      );
    });
  }
}
